import PartnersSimulator from "@interco/credito-imobiliario-simulador2-parceiros";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Container from "@/components/Container";
import { AuthContext } from "@/contexts/Authentication";

const Simulator = () => {
  const AuthData = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <Container whiteBackground>
      <PartnersSimulator
        gatewaysUrls={{ "ci.api": process.env.REACT_APP_API_URL }}
        accessToken={AuthData.token}
        handleParentNavigation={navigate}
        partner={AuthData.userInfo}
      />
    </Container>
  );
};

export default Simulator;
